import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { Button, Modal } from '@weezevent/nacre';

export default function ConfirmModal({
    allowExternalClosing = false,
    objectToSave = null,
    onAccept,
    onClose,
    labelButton = null,
    labelTitle = null,
    labelSubtitle = null,
    labelBody = null,
    disabled,
    isSubmitting,
    ...props
}) {
    const { t } = useTranslation();
    labelButton = labelButton || t('ticket.common.action.confirm');
    labelTitle = labelTitle || t('ticket.modal.confirmTitle');
    labelBody = labelBody || '';

    if (!objectToSave) {
        return null;
    }

    return (
        <Modal
            allowExternalClosing={allowExternalClosing}
            open={Boolean(objectToSave)}
            onClose={onClose}
            title={labelTitle}
            subtitle={labelSubtitle}
            submitButton={<Button primary onClick={() => onAccept(objectToSave)} label={labelButton} disabled={disabled} isLoading={isSubmitting} />}
            cancelButton={onClose && <Button onClick={onClose} label={t(`ticket.common.action.cancel`)} />}
            {...props}
        >
            {labelBody}
        </Modal>
    );
}

ConfirmModal.propTypes = {
    objectToSave: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    labelTitle: PropTypes.node,
    labelSubtitle: PropTypes.node,
    labelButton: PropTypes.string,
    labelBody: PropTypes.node,
    disabled: PropTypes.bool,
    isSubmitting: PropTypes.bool
};
